import { render, staticRenderFns } from "./ModalArticles.vue?vue&type=template&id=51157bf6&"
import script from "./ModalArticles.vue?vue&type=script&lang=ts&"
export * from "./ModalArticles.vue?vue&type=script&lang=ts&"
import style0 from "./ModalArticles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports